import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../utils/FirebaseConfig';
import '../styles/Status.css';
import { FaSignOutAlt, FaExclamationTriangle } from 'react-icons/fa';
import jsPDF from "jspdf";
import 'jspdf-autotable';


const SubscriptionExpired = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [paying, setPaying] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        const storedProfile = JSON.parse(localStorage.getItem("userProfile") || "{}");

        if (storedProfile?.emailMasjid) {
            setUserData({
                uid: storedProfile.uid || "",
                emailMasjid: storedProfile.emailMasjid,
                namaMasjid: storedProfile.namaMasjid || "-",
                mosqueId: storedProfile.mosqueId || storedProfile.uid || "",
                noTelAnda: storedProfile.noTelAnda || "",
                subscriptionEnd: storedProfile.subscriptionEnd || "",
            });
            console.log("📥 Data masjid dari userProfile:", storedProfile);
        } else {
            console.warn("❌ Tiada data masjid dalam userProfile");
        }
    }, []);


    // Logout Function
    const handleLogout = async () => {
        try {
            console.log("🔴 Logging out user...");
            await signOut(auth);
            localStorage.clear();
            navigate('/');
        } catch (error) {
            console.error("❌ Logout error:", error);
        }
    };

    const handleBillplzRenewal = async () => {
        setError('');

        if (!userData?.uid || !userData?.emailMasjid) {
            setError("Maklumat akaun tidak lengkap. Sila log keluar dan log masuk semula.");
            return;
        }

        try {
            setPaying(true);
            const currentUser = auth.currentUser;
            if (!currentUser || currentUser.uid !== userData.uid) {
                throw new Error("Sesi log masuk telah tamat. Sila log masuk semula.");
            }
            const idToken = await currentUser.getIdToken();

            const response = await fetch(
                "https://us-central1-etikaf-admin.cloudfunctions.net/createBillplzPayment",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${idToken}`,
                    },
                    body: JSON.stringify({
                        type: "renewal",
                        uid: userData.uid,
                        mosqueId: userData.mosqueId,
                        email: userData.emailMasjid,
                        name: userData.namaMasjid,
                        phone: userData.noTelAnda || "",
                    }),
                }
            );

            const data = await response.json();

            if (!response.ok || !data.billUrl) {
                throw new Error(data?.error || "Gagal menjana bil Billplz.");
            }

            window.location.href = data.billUrl;
        } catch (err) {
            console.error("❌ Renewal Billplz error:", err);
            setError(err.message || "Gagal pergi ke halaman bayaran.");
            setPaying(false);
        }
    };

    const generateInvoicePDF = async () => {
        const emailMasjid = userData?.emailMasjid;
        if (!emailMasjid) {
            console.warn("❌ Tiada email masjid.");
            return;
        }

        console.log("📄 Menjana invois untuk:", emailMasjid);
        const today = new Date().toLocaleDateString("ms-MY");

        const doc = new jsPDF();

        // ✅ Muat logo sebagai imej Base64
        const logoUrl = "/images/e-icon.png";
        const getBase64Image = (url) =>
            new Promise((resolve) => {
                const img = new Image();
                img.crossOrigin = "Anonymous";
                img.onload = function () {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    resolve(canvas.toDataURL("image/png"));
                };
                img.src = url;
            });

        const logoBase64 = await getBase64Image(logoUrl);

        // ✅ Header: Logo + Tajuk
        doc.addImage(logoBase64, "PNG", 20, 10, 12, 12);
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text("INVOIS LANGGANAN SISTEM ETIKAF", 35, 18);

        doc.setFontSize(11);
        doc.setFont("helvetica", "normal");
        doc.text(`Tarikh: ${today}`, 190, 25, null, null, "right");

        doc.line(20, 30, 190, 30); // Garis bawah tajuk

        // ✅ Info Masjid
        doc.text("Kepada:", 20, 40);
        doc.text(userData.namaMasjid, 20, 47);
        doc.text(userData.emailMasjid, 20, 54);


        // ✅ Bahagian Caj


        doc.setFont("helvetica", "normal");
        doc.autoTable({
            startY: 60,
            head: [["Keterangan", "Kuantiti", "Harga Seunit", "Jumlah"]],
            body: [
                ["Langganan Sistem (12 bulan)", "12", "RM50", "RM600"],
            ],
            styles: { fontSize: 11 },
            headStyles: { fillColor: [41, 128, 185] }, // Biru
            theme: "grid"
        });

        // ✅ Maklumat Pembayaran
        doc.setFont("helvetica", "bold");
        doc.text("Maklumat Pembayaran", 20, doc.autoTable.previous.finalY + 15);

        doc.setFont("helvetica", "normal");
        const paymentInfo = [
            "Nama Akaun: Etikaf Enterprise",
            "Bank: CIMB Bank",
            "No. Akaun: 8603024519",
        ];
        paymentInfo.forEach((line, i) =>
            doc.text(line, 20, doc.autoTable.previous.finalY + 25 + (i * 7))
        );

        // ✅ Nota
        doc.setFont("helvetica", "italic");
        doc.text("Rujukan: Langganan Sistem Etikaf (1 Tahun)", 20, doc.autoTable.previous.finalY + 45);

        // ✅ Footer
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(
            "Invois ini dijana secara automatik oleh sistem Etikaf • www.etikaf.com",
            105,
            285,
            null,
            null,
            "center"
        );

        doc.save(`Invois_Langganan_${emailMasjid}.pdf`);
    };



    const subscriptionEndDate = userData?.subscriptionEnd
        ? new Date(userData.subscriptionEnd)
        : null;
    const hasValidSubscriptionEnd = subscriptionEndDate && !Number.isNaN(subscriptionEndDate.getTime());
    const isExpired = !hasValidSubscriptionEnd || subscriptionEndDate <= new Date();
    const formattedSubscriptionEnd = hasValidSubscriptionEnd
        ? new Intl.DateTimeFormat('ms-MY', {
            day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Asia/Kuala_Lumpur'
        }).format(subscriptionEndDate)
        : '';

    return (
        <div className="card-container">
            <div className="loginHeader">
                <div className="logo-group-login">
                    <img src="/images/e-icon.png" className="logo-login" alt="Etikaf" />
                    <span className="badge-login">Admin</span>
                </div>
            </div>

            <div className="status-container">
                <h2 className="status-title">
                    <FaExclamationTriangle color="#d32f2f" style={{ marginRight: '8px' }} />
                    {isExpired ? 'Langganan Tidak Aktif' : 'Pembaharuan Langganan'}
                </h2>
                <p className="status-message">
                    {isExpired
                        ? 'Langganan anda telah tamat. Sila perbaharui untuk meneruskan Etikaf Admin dan ETV.'
                        : `Langganan semasa aktif sehingga ${formattedSubscriptionEnd}.`}
                </p>
                <p className="status-detail">
                    Caj langganan adalah RM50 sebulan (dibayar sekaligus untuk tempoh setahun: RM600).
                </p>
                <div className="info-box">
                    <p><strong>Caj:</strong> RM50/sebulan</p>
                    <p><strong>Jumlah Bayaran Setahun:</strong> RM600</p>
                    {formattedSubscriptionEnd && <p><strong>Tarikh Tamat Semasa:</strong> {formattedSubscriptionEnd}</p>}
                    <p>
                        <strong>Bagaimana tempoh dikira:</strong> Etikaf Admin dan ETV menggunakan satu tempoh
                        langganan yang sama. Setiap bayaran menyambung 12 bulan daripada tarikh tamat semasa,
                        bukan tarikh bayaran. Ini kerana ETV masih beroperasi selama tempoh ihsan selepas Admin tamat.
                    </p>
                    <p>
                        <strong>Tempoh ihsan ETV:</strong> 14 hari selepas tarikh tamat. Selepas itu ETV akan
                        berhenti memaparkan kandungan masjid dan hanya menunjukkan paparan jam neutral. Sebarang
                        peringatan bayaran hanya dipaparkan di Etikaf Admin, bukan pada skrin awam ETV.
                    </p>
                </div>



                {userData?.emailMasjid && (
                    <button className="invoice-button" onClick={generateInvoicePDF}>
                        🧾 Muat Turun Invois
                    </button>
                )}



                {error && <p className="error-message">{error}</p>}

                {/* ✅ Payment Upload Section */}
                <div className="payment-section">
                    <div className="payment-box">
                        <p className="payment-title">
                            <strong>Perbaharui langganan secara automatik melalui Billplz</strong>
                        </p>

                        <button
                            className="loginButton"
                            onClick={handleBillplzRenewal}
                            disabled={paying}
                        >
                            {paying ? "Membuka Billplz..." : "Bayar Sekarang RM600"}
                        </button>

                        <p className="status-detail" style={{ marginTop: "12px" }}>
                            Selepas bayaran berjaya, 12 bulan akan ditambah pada tarikh tamat langganan semasa.
                        </p>
                    </div>
                </div>

                {/* Logout Button */}
                <button className="logout-button" onClick={handleLogout}>
                    <FaSignOutAlt size={20} /> Keluar
                </button>
            </div>
        </div>
    );
};

export default SubscriptionExpired;
